module.exports = __webpack_public_path__ + "vg.svg?7f116b572e84ddd12d49a52e5ee237c4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/vg.svg
// module id = 1165
// module chunks = 27